import { useSyncExternalStore } from 'react'
import {
  DEFAULT_ACTIVE_CONTEXT,
  getActiveContext,
  subscribeActiveContext,
} from '@kiao-voice/api-client'

/**
 * React binding for the client-side active-context store
 * (`@kiao-voice/api-client`). Returns the current context key (`'personal'` or
 * `org:<id>`) and re-renders the component whenever the user switches
 * workspaces, so context-scoped views can re-run their loaders.
 *
 * Shared by web and desktop — both read from the same api-client store, so the
 * hook lives here in `@kiao-voice/hooks` rather than being duplicated per app.
 *
 * Built on `useSyncExternalStore` so it stays consistent with the store the
 * request wrappers read from (no tearing) and is SSR-safe — the server snapshot
 * is always the default `'personal'`, since the persisted value lives in the
 * browser's localStorage and isn't available during render on the server.
 */
export function useActiveContext(): string {
  return useSyncExternalStore(
    subscribeActiveContext,
    getActiveContext,
    () => DEFAULT_ACTIVE_CONTEXT
  )
}
